package com.exura.components

import androidx.compose.runtime.Composable
import com.exura.ui.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.CSSLengthOrPercentageValue
import org.jetbrains.compose.web.css.px


@Composable
fun Icon(
    iconSrc: String? = null,
    modifier: Modifier = Modifier,
    color: ExuraRgba? = null,
    backgroundColor: ExuraRgba? = null,
    iconFamily: String = IconFamily.UNTILED_UI,
    size: CSSLengthOrPercentageValue = 24.px
) {
    val mod = if (color != null) Modifier.color(color) else Modifier

    SpanText(
        text = iconSrc ?: Assets.IconsUntiled.PLACEHOLDER,
        modifier = mod
            .background(backgroundColor ?: ExuraColors.TRANSPARENT)
            .fontFamily(iconFamily)
            .fontSize(size)
            .then(modifier),
    )
}
